import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";
import FileUploader from "../../../../TCPForms/reusableComponents/FileUploader";



const SubStep3 = ({ formData, handleSubTabChange }) => {
    const { t } = useTranslation();
    const defaultValues = {
        ...formData,
    };
    const { handleSubmit, control, setValue, watch, reset, getValues } = useForm({defaultValues});
    const onSubmit = (data) => {
        handleSubTabChange(3, data)
    };
    return (
        <section className="groupContainer">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="formContainer">
                    <div className="formHeaderContainer">
                        <h2 className="formHeading">Applicant Information</h2>
                    </div>

                    <div className="formInputContainer">
                        <div className="columnWrapper">
                            <InputWrapper
                                label={t("LABEL_ENTER_NAME")}
                                control={control}
                                placeholder={t("LABEL_ENTER_NAME")}
                                defaultValue={formData?.applicant?.name}
                                name='applicant.name'
                                type="textInput"
                                maxLength={30}
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required",
                                    },
                                    pattern: {
                                        value: Digit.Utils.getPattern("Name"),
                                        message: "Please enter only letters and spaces",
                                    },
                                }}
                            />
                            <InputWrapper
                                label={t("LABEL_EMAIL_ID")}
                                control={control}
                                placeholder={t("LABEL_ENTER_EMAIL_ID")}
                                defaultValue={formData?.applicant?.emailId}
                                name={`applicant.emailId`}
                                type="textInput"
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required",
                                    },
                                    pattern: {
                                        value: Digit.Utils.getPattern("Email"),
                                        message: "Please enter valid email id",
                                    },
                                }}
                            />
                            <FileUploader
                                control={control}
                                name="authorization Letter"
                                label={t("Authorization Letter")}
                                validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                                isMandatory
                                required
                                tab={1}
                            />
                        </div>
                        <div className="columnWrapper">
                            <InputWrapper
                                control={control}
                                label={t("LABEL_ADDRESS")}
                                placeholder={t("LABEL_ENTER_ADDRESS")}
                                defaultValue={formData?.applicant?.address}
                                name={`applicant.address`}
                                type="textInput"
                                mandatory
                                multiLine
                                maxLength={150}
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required"
                                    },
                                    pattern: {
                                        value: Digit.Utils.getPattern('Address'),
                                        message: "Please enter valid Address",
                                    },
                                }}
                            />
                            <InputWrapper
                                control={control}
                                label="Mobile Number(As in Aadhaar)"
                                placeholder={t("LABEL_ENTER_MOBILE_NO")}
                                defaultValue={formData?.applicant?.mobileNumber}
                                name={`applicant.mobileNumber`}
                                type="textInput"
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required",
                                    },
                                    pattern: {
                                        value: Digit.Utils.getPattern("MobileNo"),
                                        message: "Please enter valid mobile no",
                                    },
                                }}
                                maxLength={10}
                            />
                            <InputWrapper
                                label={t("LABEL_AADHAAR_NUMBER")}
                                control={control}
                                placeholder={t("LABEL_ENTER_AADHAAR_NO")}
                                defaultValue={formData?.applicant?.aadhaarNumber}
                                name={`applicant.aadhaarNumber`}
                                type="textInput"
                                mandatory
                                validation={{
                                    pattern: {
                                        value: Digit.Utils.getPattern("AadharNo"),
                                        message: "Please enter valid Aadhaar no",
                                    },
                                }}
                                maxLength={12}
                            />
                        </div>
                        <br />
                    </div>

                </div>
                <div className="footerContainer">
                    <div className="buttonWrapper">
                        <ButtonWrapper
                            variant="contained"
                            color="error"
                            size="medium"
                            label="Prev"
                            sx={{ backgroundColor: '#CCC' }}
                            onClick={() => handleSubTabChange(1)}
                        />
                        <ButtonWrapper
                            variant="contained"
                            color="success"
                            size="medium"
                            label="Save"
                            type="submit"
                            sx={{ backgroundColor: '#157CB3' }}
                        />
                    </div>
                </div>
            </form>

        </section>
    );
};

export default SubStep3;
